import { AnswerCard } from "./AnswerCard";
import { QuestionCard } from "./QuestionCard";
import type {
  QuestionCard as QuestionCardType,
  AnswerCard as AnswerCardType,
} from "../types/game";

interface PatientCaseProps {
  promptElements: (QuestionCardType | AnswerCardType)[];
}

export function PatientCase({ promptElements }: PatientCaseProps) {
  if (promptElements.length === 0) {
    return null;
  }

  return (
    <div className="glass rounded-lg p-6 mb-6">
      <h2 className="font-display text-2xl font-bold mb-4">
        The Patient's Case
      </h2>
      <div className="space-y-4">
        {promptElements.map((card, idx) => {
          if (card.card_type.includes("Question")) {
            return <QuestionCard key={idx} card={card as QuestionCardType} />;
          } else {
            return <AnswerCard key={idx} card={card as AnswerCardType} />;
          }
        })}
      </div>
    </div>
  );
}
